import React, { useEffect, useState } from "react";

const Section = ({ children }) => {
  return <div className="formSection">{children}</div>;
};

export default Section;
